import { render } from "./EmailForm.vue?vue&type=template&id=55127c88"
import script from "./EmailForm.vue?vue&type=script&lang=js"
export * from "./EmailForm.vue?vue&type=script&lang=js"
script.render = render

export default script